import { render, staticRenderFns } from "./OrderActionsButton.vue?vue&type=template&id=11834613&"
import script from "./OrderActionsButton.vue?vue&type=script&lang=js&"
export * from "./OrderActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports